import React, { useState, useEffect } from "react";
import checkgif from "../../assets/gif/loading-gif.gif";
import close from "../../assets/icons/close.svg";
import { useWebSocket } from "../../Utils/WebSocketHooks";
import Notifier from "../../Utils/notify";

export const WaitExceptionalApprovalModal = ({ isOpen, onClose, onStatusChange }) => {
  const [status, setStatus] = useState({
    sent: false,
    delivered: false,
    processed: false,
  });
  const [finalStatus, setFinalStatus] = useState(null); // "approved" or "rejected"
  const [canClose, setCanClose] = useState(false);

  const wsBaseUrl = process.env.REACT_APP_API_WSS_URL;

  const { readyState, connect, disconnect } = useWebSocket(wsBaseUrl, {
    reconnect: false,
    onOpen: () => console.log("✅ Connected to WebSocket"),
    onMessage: (data) => {
      // Example: backend sends status updates
      if (data?.type === "exceptional_approval_status") {
        switch (data.data.status) {
          case "SENT":
            setStatus((prev) => ({ ...prev, sent: true }));
            break;
          case "DELIVERED":
            setStatus((prev) => ({ ...prev, sent: true, delivered: true }));
            break;
          case "PROCESSED":
            setStatus((prev) => ({ ...prev, sent: true, delivered: true, processed: true }));
            break;
          default:
            break;
        }

        // Final approval/rejection from backend
        if (data.data.final_status) {
          const backendStatus = data.data.final_status.toLowerCase();
          if (backendStatus === "approved") {
            setFinalStatus("approved");
            Notifier.success("Exceptional approval granted!");
            onStatusChange?.("approved");
          } else if (backendStatus === "rejected") {
            setFinalStatus("rejected");
            Notifier.error("Exceptional approval rejected!");
            onStatusChange?.("rejected");
          }
        }
      }
    },
    onClose: () => console.log("🔌 WebSocket disconnected"),
    onError: (err) => console.error("⚠️ WebSocket error:", err),
  });

  useEffect(() => {
    if (isOpen) connect();
    else disconnect();
  }, [isOpen, connect, disconnect]);

  useEffect(() => {
    if (finalStatus) {
      const timer = setTimeout(() => {
        setCanClose(true);
        onClose(); // auto-close after 20s
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [finalStatus, onClose]);

  if (!isOpen) return null;

  const Step = ({ active, label, rejected }) => (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          border: "2px solid #999",
          backgroundColor: rejected ? "red" : active ? "#4caf50" : "transparent",
          marginBottom: 5,
        }}
      />
      <span style={{ fontSize: 12, color: rejected ? "red" : active ? "#000" : "#999" }}>{label}</span>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{
          position: "relative",
          width: "80%",
          maxWidth: "500px",
          borderRadius: "12px",
          padding: 20,
        }}
      >
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <img src={close} alt="close" width="18" />
        </button>

        <div style={{ textAlign: "center" }}>
          <img src={checkgif} alt="waiting" style={{ width: 200, height: 200 }} />

          {/* Status Steps */}
          <div style={{ display: "flex", justifyContent: "space-around", margin: "20px 0" }}>
            <Step active={status.sent} label="Sent" />
            <Step active={status.delivered} label="Delivered" />
            <Step active={status.processed} label="Processed" />
            <Step
              active={finalStatus === "approved" || finalStatus === "rejected"}
              rejected={finalStatus === "rejected"}
              label={
                finalStatus === "approved"
                  ? "Approved"
                  : finalStatus === "rejected"
                    ? "Rejected"
                    : "Approval"
              }
            />
          </div>

          {/* Final status message */}
          {finalStatus && (
            <p
              style={{
                fontSize: 14,
                fontWeight: "bold",
                color: finalStatus === "rejected" ? "red" : "#7F56DA",
              }}
            >
              Exceptional approval has been {finalStatus}. You can close this now.
            </p>
          )}

          {/* WebSocket status */}
          <p style={{ fontSize: 13, color: "#666" }}>
            WebSocket status:{" "}
            {readyState === 0
              ? "Connecting..."
              : readyState === 1
                ? "Connected"
                : readyState === 2
                  ? "Closing..."
                  : readyState === 3
                    ? "Closed"
                    : "Not connected"}
          </p>
        </div>
      </div>
    </div>
  );
};
